import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { BoardDocument, BoardDocumentListResponse } from '../models/documents';

export const onGetBoardDocumentsList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<BoardDocumentListResponse>>('dashboard/board-documents', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetBoardDocumentById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<BoardDocument>>(`dashboard/board-documents/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateBoardDocument = async (payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<BoardDocument>>(`dashboard/board-documents`, payload, {});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateBoardDocument = async (id: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<BoardDocument>>(`dashboard/board-documents/${id}`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteBoardDocument = async (id: number) => {
	try {
		const response = await axios.delete(`dashboard/board-documents/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
